import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--menu",
  "use": "icon-arrow--menu-usage",
  "viewBox": "0 0 32 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 12\" id=\"icon-arrow--menu\"><g clip-path=\"url(#icon-arrow--menu_a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.334.5 25.27 1.531l3.852 3.74H0v1.458h29.122l-3.852 3.739 1.064 1.032 4.602-4.468L32 6.003 31.999 6v-.002l-1.062-1.03h-.001L26.334.5Z\" fill=\"currentColor\" /></g><defs><clipPath id=\"icon-arrow--menu_a\"><path fill=\"#fff\" d=\"M0 0h32v12H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol